import { useNavigate } from "react-router-dom";
import { Archive, ClipboardList, ListOrdered, Award, ArrowRight } from "lucide-react";
import { useAppContext } from "@/app/ContextProvider";
import { RequireContext, EmptyState } from "@/components/StateViews";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function ArchivePage() {
  return (
    <RequireContext>
      <ArchiveList />
    </RequireContext>
  );
}

function ArchiveList() {
  const { tournaments, tournamentId, setTournamentId } = useAppContext();
  const navigate = useNavigate();

  if (tournaments.length === 0) return <EmptyState title="Nincs bajnokság" icon={<Archive className="size-7" />} />;

  function open(id: string, to: string) {
    setTournamentId(id);
    navigate(to);
  }

  return (
    <div className="space-y-4">
      <div>
        <h1 className="flex items-center gap-2 text-xl font-semibold tracking-tight">
          <Archive className="size-5 text-primary" /> Archívum
        </h1>
        <p className="text-sm text-muted-foreground">Válts bármelyik (aktív vagy korábbi) bajnokságra, és nézd vissza a tabellát, tippjeidet, kitűzőidet.</p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        {tournaments.map((t) => {
          const active = t.id === tournamentId;
          return (
            <Card key={t.id} className={cn(active && "border-primary/50")}>
              <CardContent className="space-y-3 p-4">
                <div className="flex items-center gap-2">
                  <span className="min-w-0 flex-1 truncate font-semibold">{t.name}</span>
                  {active && <Badge>Aktív</Badge>}
                  {t.code && <Badge variant="outline">{t.code}</Badge>}
                </div>
                <div className="flex flex-wrap gap-2">
                  <Button size="sm" variant="outline" onClick={() => open(t.id, "/tabella")}><ListOrdered className="size-4" /> Tabella</Button>
                  <Button size="sm" variant="outline" onClick={() => open(t.id, "/tippjeim")}><ClipboardList className="size-4" /> Tippjeim</Button>
                  <Button size="sm" variant="outline" onClick={() => open(t.id, "/kituzok")}><Award className="size-4" /> Kitűzők</Button>
                  <Button size="sm" variant="ghost" onClick={() => open(t.id, "/")}>Megnyitás <ArrowRight className="size-4" /></Button>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
